// shared helpers for admin UI
export const STATUS_META = {
  nuova_richiesta:        { label: "Nuova richiesta",          color: "#0B192C", bg: "#E2E8F0" },
  da_contattare:          { label: "Da contattare",            color: "#0B192C", bg: "#FEF3C7" },
  in_ricerca_preventivi:  { label: "In ricerca preventivi",    color: "#0B192C", bg: "#DBEAFE" },
  preventivo_inviato:     { label: "Preventivo inviato",       color: "#0B192C", bg: "#CFFAFE" },
  preventivi_inviati:     { label: "Preventivi inviati",       color: "#FFFFFF", bg: "#0EA5E9" },
  cliente_interessato:    { label: "Cliente interessato",      color: "#FFFFFF", bg: "#C4A26C" },
  in_trattativa:          { label: "In trattativa",            color: "#FFFFFF", bg: "#00B4D8" },
  prenotazione_confermata:{ label: "Prenotazione confermata",  color: "#FFFFFF", bg: "#0B192C" },
  persa:                  { label: "Persa",                    color: "#FFFFFF", bg: "#DC2626" },
  non_compatibile:        { label: "Non compatibile",          color: "#475569", bg: "#F1F5F9" },
  follow_up_necessario:   { label: "Follow-up necessario",     color: "#0B192C", bg: "#D4AF37" },
};

export const PROBABILITY_META = {
  bassa: { label: "Bassa", emoji: "🔴", pct: 10 },
  media: { label: "Media", emoji: "🟡", pct: 50 },
  alta:  { label: "Alta",  emoji: "🟢", pct: 90 },
};

export const BOAT_LABELS = {
  sailboat: "Barca a vela",
  catamaran: "Catamarano",
  yacht: "Yacht",
  motorboat: "Motoscafo / barca a motore",
  gommone: "Gommone",
  any: "Non specificato",
};

export const ACCOM_LABELS = {
  single_cabin: "Cabina singola",
  multi_cabin: "Più cabine",
  whole_boat: "Intera barca",
  advise: "Consigliami",
};

export const GROUP_LABELS = {
  solo: "Solo", couple: "Coppia", family: "Famiglia",
  friends: "Amici", company: "Azienda", other: "Altro",
};

export const EXP_LABELS = {
  relax: "Relax totale", relax_totale: "Relax totale",
  calette: "Mare e calette", mare_calette: "Mare e calette",
  party: "Festa e divertimento", festa: "Festa e divertimento",
  luxury: "Lusso", premium: "Lusso",
  romantic: "Esperienza romantica", romantica: "Esperienza romantica",
  family_kids: "Famiglia con bambini", family: "Famiglia con bambini",
  adventure: "Avventura", avventura: "Avventura",
  sport_sail: "Sport / vela", sport: "Sport / vela",
  teambuilding: "Team building aziendale",
  mix: "Mix di tutto",
  other: "Altro", altro: "Altro",
  snorkeling: "Mare e calette",
  nature: "Avventura",
};

export function fmtEur(n) {
  if (n == null || isNaN(n)) return "—";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
}

export function fmtDate(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return s; }
}

export function fmtDateOnly(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return s; }
}

/**
 * Periodo display logic coerente con questionario cliente.
 * Ritorna { badge, lines[] } per uso flessibile in tabelle e card.
 */
export function formatPeriod(lead) {
  if (!lead) return { badge: "—", lines: [] };
  if (lead.date_mode === "precise") {
    const start = lead.start_date ? fmtDateOnly(lead.start_date) : null;
    const end = lead.end_date ? fmtDateOnly(lead.end_date) : null;
    return {
      badge: "Date precise",
      badgeColor: "#0B192C",
      badgeBg: "#FEF3C7",
      lines: start && end ? [`${start}`, `→ ${end}`] : start ? [start] : [],
    };
  }
  if (lead.date_mode === "flexible") {
    const month = lead.flexible_month
      ? lead.flexible_month.charAt(0).toUpperCase() + lead.flexible_month.slice(1)
      : null;
    const dur = lead.flexible_duration;
    let durLabel = "";
    if (dur === "7" || dur === 7) durLabel = "1 settimana";
    else if (dur === "10" || dur === 10) durLabel = "10 giorni";
    else if (dur === "14" || dur === 14) durLabel = "2 settimane";
    else if (dur) durLabel = `${dur} giorni`;
    const lines = [];
    if (month) lines.push(`Mese preferito: ${month}`);
    if (durLabel) lines.push(`Durata indicativa: ${durLabel}`);
    return {
      badge: "Sono flessibile",
      badgeColor: "#0B192C",
      badgeBg: "#DBEAFE",
      lines,
    };
  }
  if (lead.date_mode === "best_deals") {
    return {
      badge: "Le migliori occasioni",
      badgeColor: "#FFFFFF",
      badgeBg: "#C4A26C",
      lines: ["Cliente aperto a qualsiasi periodo conveniente"],
    };
  }
  return { badge: "—", lines: [] };
}

/** Compact one-liner for table cell */
export function formatPeriodInline(lead) {
  const p = formatPeriod(lead);
  if (p.lines.length === 0) return p.badge;
  return `${p.badge} · ${p.lines.join(" · ")}`;
}
